import { useEffect, useState } from 'react'
import queryString from 'query-string'
import { useCookies } from 'react-cookie'

import { authTokenCookieName, cookieOptions } from './util/cookies'

export const App = ({ children }) => {
  const [, setCookie] = useCookies([authTokenCookieName])
  const [isEffectComplete, setIsEffectComplete] = useState(false)

  useEffect(() => {
    const parsedHash = queryString.parse(window.location.hash)

    if (parsedHash.access_token) {
      setCookie(authTokenCookieName, parsedHash.access_token.toString(), cookieOptions)
      window.location.hash = ''
    }

    setIsEffectComplete(true)
  }, [setCookie])

  if (!isEffectComplete) {
    return null
  }

  return <>{children}</>
}
